import { BundleCollectionHandle, CollectionHandle } from '../enums/CollectionHandle.enum';
import { Color } from '../enums/Color.enum';
import { ProductHandle } from '../enums/ProductHandle.enum';
import { ProductTag } from '../enums/ProductTag.enum';

interface ColorCombo {
  productHandle: ProductHandle;
  color: Color;
  quantity: number;
}

interface ProductColorCombo {
  swatchTitle: string;
  imageAssetUrl: string;
  colorCombos: ColorCombo[];
}

export interface BundleConfig {
  title: string; // FIXME: This is currently used to support looking up collection titles without having to dump all collections from Liquid
  percentageDiscount: number;
  productColorCombos: ProductColorCombo[];
  showForProductTags?: ProductTag[];
  isFinalSale?: boolean;
}

export const bundleConfiguration: Record<BundleCollectionHandle, BundleConfig> = {
  [BundleCollectionHandle.SilhouetteBundle]: {
    title: 'Silhouette Bundle',
    isFinalSale: true,
    percentageDiscount: 15,
    showForProductTags: ['collection_bras', 'collection_underwear'],
    productColorCombos: [
      // {
      //   swatchTitle: 'Moondust2',
      //   imageAssetUrl: 'silhouette-bundle-moondust2.jpg',
      //   colorCombos: [
      //     { quantity: 1, color: Color.Moondust2, productHandle: ProductHandle.SilhouetteBra },
      //     { quantity: 1, color: Color.Moondust2, productHandle: ProductHandle.SilhouetteBrief },
      //   ],
      // },
      {
        swatchTitle: 'Sand',
        imageAssetUrl: 'silhouette-bundle-sand.jpg',
        colorCombos: [
          { quantity: 1, color: Color.Sand, productHandle: ProductHandle.SilhouetteBra },
          { quantity: 1, color: Color.Sand, productHandle: ProductHandle.SilhouetteBrief },
        ],
      },
      {
        swatchTitle: 'Astral',
        imageAssetUrl: 'silhouette-bundle-astral.jpg',
        colorCombos: [
          { quantity: 1, color: Color.Astral, productHandle: ProductHandle.SilhouetteBra },
          { quantity: 1, color: Color.Astral, productHandle: ProductHandle.SilhouetteBrief },
        ],
      },
      {
        swatchTitle: 'RoseTan',
        imageAssetUrl: 'silhouette-bundle-rosetan.jpg',
        colorCombos: [
          { quantity: 1, color: Color.RoseTan, productHandle: ProductHandle.SilhouetteBra },
          { quantity: 1, color: Color.RoseTan, productHandle: ProductHandle.SilhouetteBrief },
        ],
      },
      {
        swatchTitle: 'Moondust',
        imageAssetUrl: 'silhouette-bundle-moondust.jpg',
        colorCombos: [
          { quantity: 1, color: Color.Moondust, productHandle: ProductHandle.SilhouetteBra },
          { quantity: 1, color: Color.Moondust, productHandle: ProductHandle.SilhouetteBrief },
        ],
      },
      {
        swatchTitle: 'Cinnamon',
        imageAssetUrl: 'silhouette-bundle-cinnamon.jpg',
        colorCombos: [
          { quantity: 1, color: Color.Cinnamon, productHandle: ProductHandle.SilhouetteBra },
          { quantity: 1, color: Color.Cinnamon, productHandle: ProductHandle.SilhouetteBrief },
        ],
      },
      {
        swatchTitle: 'Peony',
        imageAssetUrl: 'silhouette-bundle-peony.jpg',
        colorCombos: [
          { quantity: 1, color: Color.Peony, productHandle: ProductHandle.SilhouetteBra },
          { quantity: 1, color: Color.Peony, productHandle: ProductHandle.SilhouetteBrief },
        ],
      },
      {
        swatchTitle: 'Fig',
        imageAssetUrl: 'silhouette-bundle-fig.jpg',
        colorCombos: [
          { quantity: 1, color: Color.Fig, productHandle: ProductHandle.SilhouetteBra },
          { quantity: 1, color: Color.Fig, productHandle: ProductHandle.SilhouetteBrief },
        ],
      },
      {
        swatchTitle: 'Vamp',
        imageAssetUrl: 'silhouette-bundle-vamp.jpg',
        colorCombos: [
          { quantity: 1, color: Color.Vamp, productHandle: ProductHandle.SilhouetteBra },
          { quantity: 1, color: Color.Vamp, productHandle: ProductHandle.SilhouetteBrief },
        ],
      },
    ],
  },
};

Object.freeze(bundleConfiguration);
